import { render, staticRenderFns } from "./userFrom.vue?vue&type=template&id=85222e4a&scoped=true"
import script from "./userFrom.vue?vue&type=script&lang=js"
export * from "./userFrom.vue?vue&type=script&lang=js"
import style0 from "./userFrom.vue?vue&type=style&index=0&id=85222e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85222e4a",
  null
  
)

export default component.exports